import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function MenuDropdown() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const handleLogout = () => {
    logout();
    alert('Sei stato disconnesso.');
    navigate('/');
    setMenuOpen(false);
  };

  return (
    <div className={`dropdown ${menuOpen ? 'show' : ''}`}>
      <button
        className="dropbtn"
        onClick={toggleMenu}
        aria-haspopup="true"
        aria-expanded={menuOpen}
      >
        Menu
      </button>
      <div className="dropdown-content" role="menu">
        <Link to="/" onClick={() => setMenuOpen(false)} role="menuitem">
          Home
        </Link>
        {!user && (
          <Link to="/registration" onClick={() => setMenuOpen(false)} role="menuitem">
            Registrati
          </Link>
        )}
        {!user && (
          <Link to="/login" onClick={() => setMenuOpen(false)} role="menuitem">
            Accedi
          </Link>
        )}
        {user && (
          <Link to="/my-coupons" onClick={() => setMenuOpen(false)} role="menuitem">
            Cupon
          </Link>
        )}
        {user && (
          <Link to="/loyaltycard" onClick={() => setMenuOpen(false)} role="menuitem">
            Carta Fedeltà
          </Link>
        )}
        {user && (
          <Link to="/profile" onClick={() => setMenuOpen(false)} role="menuitem">
            Profilo
          </Link>
        )}
        <Link to="/info" onClick={() => setMenuOpen(false)} role="menuitem">
          Info
        </Link>
        <Link to="/help" onClick={() => setMenuOpen(false)} role="menuitem">
          Aiuto
        </Link>
        {user && (
          <button className="logout-btn" onClick={handleLogout} role="menuitem">
            Logout
          </button>
        )}
      </div>
    </div>
  );
}